import {connect} from "react-redux";
import {viewImage} from "../../../../actions/Chats";

import MessageText from './MessageText';

const MessageImage = ({message, viewImage}) => {
    return message.image_url && <><div onClick={() => viewImage(message.image_url)}>
        <img alt={message.text} src={message.image_url}/>
    </div>
    <MessageText text={message.text}/>
    </>
}

const mapDispatchToProps = dispatch => ({
    viewImage: (image) => dispatch(viewImage(image)),
});

export default connect(undefined, mapDispatchToProps)(MessageImage);